import { createFileRoute } from "@tanstack/react-router"
import { PageRequest } from "../../../@client/Theasoft_ApiServer__Utils_Pagination"
import { ResourceFilter, ResourcePageRequest } from "@/orval/gen/model"
import { ResourcesPage } from "./-components/ResourcesPage"

export interface ResourceSearch
  extends Omit<ResourcePageRequest, keyof PageRequest> {}

export const Route = createFileRoute("/app/resources/resources")({
  component: ResourcesPage,
  beforeLoad: ({ context: { t } }) => ({
    getTitle: () => t && t("Resources_Title"),
  }),
  validateSearch: (search: ResourceSearch) => ({
    ...search,
    filter: {
      ...search.filter,
      availableCount: search.filter?.availableCount ?? 1,
    } as ResourceFilter,
  }),
})
